import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgFaceGrin = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "currentColor", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m5.495.93A.5.5 0 0 0 6.5 13c0 1.19.644 2.438 1.618 3.375C9.099 17.319 10.469 18 12 18s2.9-.681 3.882-1.625c.974-.937 1.618-2.184 1.618-3.375a.5.5 0 0 0-.995-.07.8.8 0 0 1-.156.096c-.214.106-.554.208-1.006.295-.896.173-2.111.262-3.343.262s-2.447-.09-3.343-.262c-.452-.087-.792-.19-1.005-.295a.8.8 0 0 1-.157-.096M8.99 8a1 1 0 0 0 0 2H9a1 1 0 1 0 0-2zm6 0a1 1 0 1 0 0 2H15a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  }
) }));

export { SvgFaceGrin as default };
//# sourceMappingURL=face-grin.mjs.map
